import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaGraduationCap, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import apiService from '../services/api';

const Footer = () => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await apiService.getSettings();
      if (response.data.success) {
        setSettings(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Column */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-to-r from-primary-500 to-secondary-500 p-2 rounded-lg">
                <FaGraduationCap className="text-white text-2xl" />
              </div>
              <h3 className="text-white text-xl font-display font-bold">
                EduConsult
              </h3>
            </div>
            <p className="text-sm mb-4 leading-relaxed">
              {settings.site_tagline || 'Your Gateway to Top Colleges'}
            </p>
            <div className="flex space-x-3">
              {settings.facebook_url && (
                <a
                  href={settings.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-all duration-300 transform hover:scale-110"
                >
                  <FaFacebook className="text-white" />
                </a>
              )}
              {settings.twitter_url && (
                <a
                  href={settings.twitter_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-all duration-300 transform hover:scale-110"
                >
                  <FaTwitter className="text-white" />
                </a>
              )}
              {settings.instagram_url && (
                <a
                  href={settings.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-all duration-300 transform hover:scale-110"
                >
                  <FaInstagram className="text-white" />
                </a>
              )}
              {settings.linkedin_url && (
                <a
                  href={settings.linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-all duration-300 transform hover:scale-110"
                >
                  <FaLinkedin className="text-white" />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/colleges', label: 'Colleges' },
                { to: '/blogs', label: 'Blog' },
                { to: '/team', label: 'Our Team' },
                { to: '/contact', label: 'Contact Us' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm hover:text-primary-400 transition-colors duration-200 flex items-center group"
                  >
                    <span className="w-0 group-hover:w-4 h-px bg-primary-400 transition-all duration-200 mr-0 group-hover:mr-2"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                College Admission Guidance
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                Course Selection Counseling
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                Entrance Exam Preparation
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                Career Planning
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                Document Assistance
              </li>
              <li className="flex items-start">
                <span className="text-primary-400 mr-2">•</span>
                Scholarship Guidance
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <FaPhone className="text-primary-400 mt-1 mr-3" />
                <span>{settings.contact_phone || '+91-9876543210'}</span>
              </li>
              <li className="flex items-start">
                <FaEnvelope className="text-primary-400 mt-1 mr-3" />
                <span>{settings.contact_email || 'info@educonsult.com'}</span>
              </li>
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-primary-400 mt-1 mr-3" />
                <span>{settings.contact_address || '123, Education Hub, New Delhi, India - 110001'}</span>
              </li>
            </ul>
            <Link
              to="/register"
              className="mt-6 inline-block btn btn-primary text-sm"
            >
              Get Free Consultation
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p className="mb-4 md:mb-0">
              © {currentYear} EduConsult. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/" className="hover:text-primary-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/" className="hover:text-primary-400 transition-colors">
                Terms of Service
              </Link>
              <Link to="/" className="hover:text-primary-400 transition-colors">
                Sitemap
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
